import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Vehicle } from '@sm360/widget-commons-vehicle';
import { ContentZonesService } from '@sm360/widget-commons-core-services';

import { COLANDER_GROUPS } from 'inventory-listing/constants/colanders.js';

import ListingSEOText from 'inventory-listing/components/ListingSEOText/ListingSEOText.jsx';

import './ListingFooter.scss';

const ListingFooter = ({ colanderGroupSlug }) => {
    // Keeping this commented code just in case in future if we want to re-enable the disclaimer again
    // const genericDisclaimers = listingUsed?.genericDisclaimers && [
    //     listingUsed?.genericDisclaimers?.dataResponsibility,
    //     listingUsed?.genericDisclaimers?.priceChange,
    // ];

    const contentZoneLegalDisclaimer = ContentZonesService.getContentZone(
        'widget.listing.used',
        'widget.listing.used.disclaimer'
    );

    const legalDisclaimerCz = contentZoneLegalDisclaimer ? contentZoneLegalDisclaimer.getValue() : '';

    return (
        <div className="listing-footer">
            <div className="sr-disclaimer">
                <Vehicle.VehicleDisclaimersContent
                    // genericDisclaimers={genericDisclaimers}
                    disclaimersContentZone={legalDisclaimerCz}
                    onOrderDisclaimer={colanderGroupSlug !== COLANDER_GROUPS.DEFAULT}
                />
            </div>
            <ListingSEOText colanderGroupSlug={colanderGroupSlug} />
        </div>
    );
};

ListingFooter.propTypes = {
    colanderGroupSlug: PropTypes.string.isRequired,
};

function mapStateToProps({ listingUsed }) {
    return { listingUsed };
}

ListingFooter.displayName = 'ListingFooter';

export { ListingFooter };

export default connect(mapStateToProps)(ListingFooter);
